import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, LOCALE_ID, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {  IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { HttpModule } from '@angular/http';
import { OrdersPageModule } from '../pages/orders/orders.module';
import { TransPageModule } from '../pages/trans/trans.module';

import { TransRejectionPageModule } from '../pages/trans-rejection/trans-rejection.module';

import { MyApp } from './app.component';
import { HomePageModule } from '../pages/home/home.module';
import { StreamPageModule } from '../pages/stream/stream.module';
import { CrmPageModule } from '../pages/crm/crm.module';
import { PartnersPageModule } from '../pages/partners/partners.module';


//import { TranslationModule } from 'angular-l10n';
//import { TerraComponentsModule } from '@plentymarkets/terra-components/app';

//import { HomePage } from '../pages/home/home';

import { LoginPageModule } from '../pages/login/login.module';

import { RestProvider } from '../providers/rest/rest';
import { AuthServiceProvider } from '../providers/auth-service/auth-service';

import { ColorPickerModule } from 'ngx-color-picker';
import { DownloadModalPageModule } from '../pages/download-modal/download-modal.module';

// File upload module
//import {FileUploadModule} from 'ng2-file-upload';

import { ImagePicker } from '@ionic-native/image-picker';
import { Camera } from '@ionic-native/camera';
import { FileTransfer } from '@ionic-native/file-transfer';

import { IonicStorageModule } from '@ionic/storage';
import { SplitPaneProvider } from '../providers/split-pane/split-pane';
import { AuthProvider } from '../providers/auth/auth';
import { OrdersProvider } from '../providers/orders/orders';


import { Http } from '@angular/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { Globalization } from '@ionic-native/globalization';
// import { HTTP_INTERCEPTORS } from '@angular/common/http';
// import { TokenInterceptor } from './../auth/token.interceptor';
// import {HttpClientModule} from '@angular/common/http';
// import { ImagePreloader } from '../directives/img-preload/img-preload';
// import { DirectivesModule } from '../directives/directives.module';

import { TooltipsModule } from 'ionic-tooltips';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {NgxPaginationModule} from 'ngx-pagination';

import { GlobalProvider } from '../providers/global/global';
import { TemplatesProvider } from '../providers/templates/templates';

// import {FormlyModule} from '@ngx-formly/core';
// import {FormlyIonicModule} from '@ngx-formly/ionic';

// Paypal native



export function createTranslateLoader(http: Http) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
//
@NgModule({
  declarations: [
    MyApp
    //HomePage,
    // ImagePreloader,
    //ImagesPage,
    //WelcomePage,
    //LoginPage,
    //CreateBlueprintPage,
    //SignupPage
    //OrdersPage
    //CreateOrderPage
  ],
  imports: [
    HttpModule,
    // DirectivesModule,
    IonicModule.forRoot(MyApp),
    TooltipsModule,
    NgxPaginationModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [Http]
      }
    }),
    IonicStorageModule.forRoot(),
    //IonicPageModule.forRoot(),
    //TerraComponentsModule.forRoot(),
    //JobsPageModule,
    OrdersPageModule,
    ColorPickerModule,
    LoginPageModule,
    TransPageModule,
    TransRejectionPageModule,
    HomePageModule,
    BrowserAnimationsModule,
    StreamPageModule,
    CrmPageModule,
    BrowserModule,
    DownloadModalPageModule,
    // FormlyModule.forRoot(),
    // FormlyIonicModule
    //FileUploadModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    //HomePage,
    //SettingsPage
    //ImagesPage,
    //WelcomePage,
    //LoginPage,
    //CreateBlueprintPage,
    //SignupPage
    //OrdersPage
    //CreateOrderPage
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: LOCALE_ID, useValue: 'de-DE' },
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    RestProvider,
    ImagePicker,
    Camera,
    FileTransfer,
    AuthServiceProvider,
    SplitPaneProvider,
    AuthProvider,
    Globalization,
    OrdersProvider,
    GlobalProvider,
    TemplatesProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts